import { Component } from "react";

import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

import CfAutosuggest from "../../../../shared/components/common/CfAutosuggest/CfAutosuggest";

export class AdminFarmSelector extends Component {
  getSuggestionValue = (sugg) =>
    [`${sugg.name} (${sugg.id})`].filter((item) => item).join(", ");

  render() {
    const { classes, isFetching } = this.props;
    const { formatMessage } = this.props.intl;
    const placeholder = formatMessage({ id: "Admin.enter-farm-name" });
    return (
      <CfAutosuggest
        alwaysRenderSuggestions
        autoFocus
        clearInputOnAdornmentClick
        clearInputOnSelect
        clearSuggestions={this.props.onSuggestionClear}
        disableUnderline
        getSuggestions={this.props.getFarmsByName}
        getSuggestionValue={this.getSuggestionValue}
        isDebounced
        isFetching={isFetching}
        multiSection={false}
        onSuggestionSelected={this.props.onSuggestionSelect}
        placeholder={placeholder}
        requiredLength={3}
        scrollable
        scrollHeightMax={300}
        suggestions={this.props.suggestions.map((sugg) => ({ ...sugg }))}
        testData="farm-selector"
        adornment={
          <IconButton disabled size="large">
            <SearchIcon />
          </IconButton>
        }
        classes={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsContainer: classes.suggestionsContainer,
          suggestionsList: classes.suggestionsList,
          suggestionItem: classes.suggestionItem,
          input: classes.input,
          positionEnd: classes.positionEnd,
        }}
      />
    );
  }
}

AdminFarmSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  suggestions: PropTypes.array,
  isFetching: PropTypes.bool,
  getFarmsByName: PropTypes.func.isRequired,
  onSuggestionClear: PropTypes.func.isRequired,
  onSuggestionSelect: PropTypes.func.isRequired,
};

AdminFarmSelector.defaultProps = {
  suggestions: [],
  isFetching: false,
};

const styles = () => ({
  container: {
    height: "100%",
  },
  suggestionsContainerOpen: {
    margin: 0,
    "-webkit-box-shadow": "none",
    "-moz-box-shadow": "none",
    "box-shadow": "none",
    position: "static",
    height: "calc(100% - 52px)",
  },
  suggestionsContainer: {
    boxShadow: "none",
    "-webkit-box-shadow": "none",
    "-moz-box-shadow": "none",
    height: "calc(100% - 52px)",
  },
  suggestionsList: {
    maxHeight: 300,
    maxWidth: 350,
  },
  suggestionItem: {
    overflow: "inherit",
  },
  input: {
    padding: "15px 15px 5px 15px",
  },
  positionEnd: {
    right: 8,
  },
});

export default injectIntl(withStyles(styles)(AdminFarmSelector));
